import Utilities from "./utilities";

class ChunkReplacer {
	replacements = [];

	add(item, value) {
		this.replacements.push({item: item, value: value});
		return this;
	}

	replace(string) {
		if (this.replacements.length > 0) {
			this.replacements.forEach((replacement) => {
				string = Utilities.replaceAll(string, '{' + replacement.item + '}', replacement.value);
			})
		}
		return string;
	}
}
module.exports = ChunkReplacer;